import { FC, useEffect, useState } from "react";
import "./AllSetScreen.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CALENDAR_RESERVATION_TYPE,
  MENU_ITEM,
  PURCHASE_TYPE,
} from "utils/constants";
import { useTabBar } from "services/TabBarProvider";
import allSetAnimation from "../../../assets/gif/all-set-screen-animation.gif";
import allSetStar from "../../../assets/images/all-set-screen-green-star.svg";
import titleCurveIcon from "../../../assets/images/reservation-side-curve-cion.svg";
import titleStarIcon from "../../../assets/images/reservation-purpole-star-cion.svg";
import ROUTE_PATHS from "utils/routePaths";
import { STORAGE_KEY } from "utils/strings";

const AllSetScreen: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSelectedTabBar } = useTabBar();
  const [paymentDetail, setPaymentDetail] = useState<any>(null);
  const [showGif, setShowGif] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowGif(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const storedData = localStorage.getItem(STORAGE_KEY.PAYMENT_SUCCESS_DATA);
    if (storedData) {
      setPaymentDetail(JSON.parse(storedData));
    }
  }, []);

  const handleBackClick = () => {
    const fromPath = (location.state as { from?: string } | null)?.from;
    if (paymentDetail?.type === PURCHASE_TYPE.EVENT) {
      if (fromPath === ROUTE_PATHS.WSM_CALENDAR_PAYMENT) {
        navigate(-2);
      } else {
        navigate(-1);
      }
    } else if (paymentDetail?.type === PURCHASE_TYPE.MEMBERSHIP) {
      navigate(-2);
    } else {
      navigate(-1);
    }
  };

  const handleReserveNowClick = () => {
    const fromPath = (location.state as { from?: string } | null)?.from;
    if (paymentDetail?.type === PURCHASE_TYPE.EVENT) {
      if (fromPath === ROUTE_PATHS.WSM_CALENDAR_PAYMENT) {
        navigate(-2);
      } else {
        navigate(-1);
      }
      setSelectedTabBar(MENU_ITEM.HOME);
    } else if (paymentDetail?.type === PURCHASE_TYPE.MEMBERSHIP) {
      navigate(-2);
    } else {
      navigate(-1);
      const calendarTab = paymentDetail?.title?.includes("Retreat")
        ? CALENDAR_RESERVATION_TYPE.RETREAT
        : paymentDetail?.serviceType;
      sessionStorage.setItem(STORAGE_KEY.CALENDAR_SELECTED_TAB, calendarTab);
      setSelectedTabBar(MENU_ITEM.CALENDAR);
    }
  };

  return (
    <div className="wms-mobile-container">
      <div className="all-set-screen-detail-screen-container">
        <div className="all-set-screen-detail-header-container">
          <div className="title">You are all set</div>
          <div className="back-container" onClick={handleBackClick}>
            ✕
          </div>
        </div>
        <div className="all-set-screen-detail-screen-content-container">
          {showGif ? (
            <img
              src={allSetAnimation}
              alt="all-set-animation"
              className="animation-container"
            />
          ) : (
            <img
              src={allSetStar}
              alt="all-set-complete"
              className="animation-container"
            />
          )}
          <span className="title">SUCCESSFULLY</span>
          <div className="title-background">
            <img
              src={titleCurveIcon}
              alt="title-curve-icon"
              className="curve"
            />
            <div className="title-container">
              <span>{paymentDetail?.title}</span>
            </div>
            <img src={titleStarIcon} alt="title-star-icon" className="star" />
          </div>
          <span className="sub-title">
            {paymentDetail?.type === PURCHASE_TYPE.EVENT
              ? "Reserved"
              : "Purchased"}
          </span>
        </div>
      </div>
      <div
        className="all-set-screen-detail-purchase-btn"
        onClick={handleReserveNowClick}
      >
        {paymentDetail?.type === PURCHASE_TYPE.EVENT
          ? "Got It"
          : paymentDetail?.type === PURCHASE_TYPE.MEMBERSHIP
            ? "Go to dashboard"
            : "Reserve Now"}
      </div>
    </div>
  );
};

export default AllSetScreen;
